import { HttpException } from './HttpException';

export class EntityNotFoundException extends HttpException {
  static readonly API_CODE = 'ENTITY_NOT_FOUND';

  constructor(message: string, httpCode?: number) {
    super(message, httpCode);

    Object.setPrototypeOf(this, EntityNotFoundException.prototype);
  }

  getApiCode(): string {
    return EntityNotFoundException.API_CODE;
  }
}
